import{useMemo as r}from"react";import{uniqueId as o}from"lodash";var t=function(t){var e=r((function(){return t||o("form-field-")}),[t]);return{id:e,labelId:"".concat(e,"-label"),errorId:"".concat(e,"-error")}};export{t as useFieldIds};
